import { Flex, Text } from '@chakra-ui/react';
import { EyeOutline } from '@aslanpay/portal-common-lib';

interface PotTabCardProps {
  title: string;
  description: string;
  indicator: string | number;
  isActive: boolean;
  onClick: () => void;
}

function PotTabCard({ title, description, indicator, isActive, onClick }: PotTabCardProps) {
  return (
    <Flex
      flexDir="column"
      gap="12px"
      flex="1"
      minW="160px"
      h="121px"
      p="16px"
      borderRadius="8px"
      border="1px solid"
      borderColor={isActive ? 'brand.darkPurple' : 'brand.lightGray1'}
      bg={isActive ? 'brand.darkPurple' : 'brand.lightGray2'}
      cursor="pointer"
      onClick={onClick}
      _hover={{ borderColor: 'brand.darkPurple' }}
      transition="background 0.15s, border-color 0.15s"
    >
      <Flex justify="space-between" align="center">
        <Text textStyle="h5Medium" color={isActive ? 'white' : 'brand.darkPurple'}>
          {title}
        </Text>
        {!isActive && <EyeOutline boxSize="20px" color="brand.purple" />}
      </Flex>

      <Text textStyle="h2" color={isActive ? 'white' : 'brand.darkPurple'} lineHeight={1}>
        {indicator}
      </Text>

      <Text textStyle="extraSmallRegular" color={isActive ? 'whiteAlpha.800' : 'brand.darkGray'}>
        {description}
      </Text>
    </Flex>
  );
}

export default PotTabCard;
